import { render, staticRenderFns } from "./ResourceSummaryComponent.vue?vue&type=template&id=01c65214"
import script from "./ResourceSummaryComponent.vue?vue&type=script&lang=js"
export * from "./ResourceSummaryComponent.vue?vue&type=script&lang=js"
import style0 from "./ResourceSummaryComponent.vue?vue&type=style&index=0&id=01c65214&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports